import { Route, Switch } from 'wouter';
import { AuthedPage } from '../app';
import { EYApplicationRoot } from './application-root/EYApplicationRoot';
import { F5ApplicationRoot } from './application-root/F5ApplicationRoot';
import { IndividualApplicationRoot } from './application-root/IndividualApplicationRoot';
import { LumenApplicationRoot } from './application-root/LumenApplicationRoot';
import { OrganizationApplicationRoot } from './application-root/OrganizationApplicationRoot';
import { ReckittApplicationRoot } from './application-root/ReckittApplicationRoot';
import { SAPApplicationRoot } from './application-root/SAPApplicationRoot';

export const APPLICATION_ROUTES = {
  SAP: '/sap',
  F5: '/f5',
  EY: '/ey',
  RECKITT: '/reckitt',
  LUMEN: '/lumen',
  INDIVIDUAL: '/individual',
  ORGANIZATION: '/organization',
};

export type ApplicationPageProps = {
  onBack: () => void;
  onContinue: () => void;
  progress: number;

  onSubmit?: () => void;
  onSaveExit?: () => void;
  isEditProfile?: boolean;
  isOrganization?: boolean;
  dataKey: ApplicationStorageDataKeys;
};

export type Step = {
  progress: number;
  component: React.ComponentType<ApplicationPageProps>;
  url: string;
};

export enum ApplicationStorageDataKeys {
  PROFESSIONAL_APPLICATION = 'professionalApplication',
  ORGANIZATION_APPLICATION = 'organizationApplication',
}

export const Application = () => {
  return (
    <AuthedPage>
      <Switch>
        <Route path={APPLICATION_ROUTES.SAP} nest>
          <SAPApplicationRoot />
        </Route>
        <Route path={APPLICATION_ROUTES.F5} nest>
          <F5ApplicationRoot />
        </Route>
        <Route path={APPLICATION_ROUTES.EY} nest>
          <EYApplicationRoot />
        </Route>
        <Route path={APPLICATION_ROUTES.LUMEN} nest>
          <LumenApplicationRoot />
        </Route>
        <Route path={APPLICATION_ROUTES.INDIVIDUAL} nest>
          <IndividualApplicationRoot />
        </Route>
        <Route path={APPLICATION_ROUTES.RECKITT} nest>
          <ReckittApplicationRoot />
        </Route>
        <Route path={APPLICATION_ROUTES.ORGANIZATION} nest>
          <OrganizationApplicationRoot />
        </Route>
      </Switch>
    </AuthedPage>
  );
};
